import React from 'react';
import Button from '../../../components/ui/Button';

const BulkActions = ({ selectedCount, onPublish, onUnpublish, onDelete }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-secondary/10 border border-secondary/20 rounded-lg p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-foreground">
          {selectedCount} post{selectedCount !== 1 ? 's' : ''} selected
        </span>
      </div>
      
      <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
        <Button
          variant="secondary"
          size="sm"
          onClick={onPublish}
          iconName="Eye"
          iconPosition="left"
          iconSize={14}
        >
          Publish
        </Button>
        <Button
          variant="secondary"
          size="sm"
          onClick={onUnpublish}
          iconName="EyeOff"
          iconPosition="left"
          iconSize={14}
        >
          Unpublish
        </Button>
        <Button
          variant="destructive"
          size="sm"
          onClick={onDelete}
          iconName="Trash2"
          iconPosition="left"
          iconSize={14}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default BulkActions;